import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { UpdateAnimalDto } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useCreateAnimalComplete() {
  const { userFarm: farmId, username } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['createAnimalComplete'],
    mutationFn: (animalData: UpdateAnimalDto) => animalController.createAnimalComplete(farmId!, username!, animalData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['getAnimalList'],
        exact: false
      })
    },
    onError: () => {
      toast.error('Erro ao criar animal completo')
    }
  })
}
